import MainModal from '@/common/components/base/modal/Modal';
import CloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';
import { useParams } from 'react-router-dom';
import LoadingButton from '@/common/components/base/button/loadingButton';
import { IBodyRemoveSubstitutionPartModalType } from '@/modules/adjusterReportModules/Insurer-information/components/expert/modals/BodyRemoveSubstitutionPartModalType';
import { useMutation } from '@tanstack/react-query';
import { deleteBodySubstitutionPartQueryOption } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodySubstitutionPart/deleteBodySubstitutionPartQueryOption';

const BodyRemoveSubstitutionPartModal: React.FC<
  IBodyRemoveSubstitutionPartModalType
> = ({ partName, removeModal, setRemoveModal, partId, completeRemove }) => {
  const { id } = useParams();
  const { mutate: removeSubstitutionPart, isPending: loading } = useMutation(
    deleteBodySubstitutionPartQueryOption(),
  );

  const removeSubstitutionPartHandler = () => {
    removeSubstitutionPart(
      {
        id: +id!,
        part_id: partId!,
        source: 'pwa',
      },
      {
        onSuccess: () => {
          setRemoveModal(false);
          completeRemove && completeRemove();
        },
      },
    );
  };
  return (
    <MainModal open={removeModal} closeModal={() => setRemoveModal(false)}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={16}
        width="100%"
      >
        <CloseIcon />
        <Typography
          textStyle="b2"
          color="black-1"
          mt={7}
        >{`آیا از حذف قطعه " ${partName} " مطمئن هستید؟`}</Typography>
        <Flex justifyContent="space-between" width="100%" gap={8} mt={34}>
          <Box flex={1}>
            <Button
              fullWidth
              variant="outlined"
              color="common"
              onClick={() => setRemoveModal(false)}
            >
              انصراف
            </Button>
          </Box>
          <Box flex={1}>
            <LoadingButton
              fullWidth
              variant="contained"
              color="danger"
              loading={loading}
              onClick={() => removeSubstitutionPartHandler()}
            >
              حذف
            </LoadingButton>
          </Box>
        </Flex>
      </Box>
    </MainModal>
  );
};
export default BodyRemoveSubstitutionPartModal;
